(function() {
  var mq = window.matchMedia('(min-width: 750px)');

  document.querySelectorAll('.product--display-gallery .product__media-wrapper, .product--display-grid .product__media-wrapper, .product--display-collage .product__media-wrapper').forEach(function(wrapper) {
    var indicator = wrapper.querySelector('.gallery-scroll-indicator');
    if (!indicator) return;

    var previousButton = indicator.querySelector('.gallery-scroll-indicator__button--previous');
    var nextButton = indicator.querySelector('.gallery-scroll-indicator__button--next');
    var track = indicator.querySelector('.gallery-scroll-indicator__track');
    var thumb = indicator.querySelector('.gallery-scroll-indicator__thumb');
    var frame;
    var dragging = false;

    function getMetrics() {
      var scrollable = wrapper.scrollHeight - wrapper.clientHeight;

      return {
        scrollable: Math.max(0, scrollable)
      };
    }

    function update() {
      if (!mq.matches) {
        indicator.classList.remove('is-scrollable');
        return;
      }

      var metrics = getMetrics();
      wrapper.style.setProperty('--gallery-indicator-top', (wrapper.clientHeight * 0.33) + 'px');

      if (metrics.scrollable <= 1) {
        indicator.classList.remove('is-scrollable');
        return;
      }

      indicator.classList.add('is-scrollable');
      var progress = Math.min(1, Math.max(0, wrapper.scrollTop / metrics.scrollable));
      var scrollCount = Math.ceil(metrics.scrollable / 500);
      var thumbHeight = Math.max(10, track.clientHeight / (scrollCount + 1));
      var thumbTravel = Math.max(0, track.clientHeight - thumbHeight);
      indicator.style.setProperty('--scroll-thumb-height', thumbHeight + 'px');
      indicator.style.setProperty('--scroll-thumb-top', (progress * thumbTravel) + 'px');
      thumb.setAttribute('aria-valuenow', Math.round(progress * 100));
    }

    function queueUpdate() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    function scrollFromTrackPosition(clientY, smooth) {
      var metrics = getMetrics();
      var trackRect = track.getBoundingClientRect();
      var progress = Math.min(1, Math.max(0, (clientY - trackRect.top) / trackRect.height));
      if (smooth) {
        wrapper.scrollTo({ top: progress * metrics.scrollable, behavior: 'smooth' });
      } else {
        wrapper.scrollTop = progress * metrics.scrollable;
      }
      queueUpdate();
    }

    function getTouchY(event) {
      var touch = event.touches[0] || event.changedTouches[0];
      return touch ? touch.clientY : 0;
    }

    function startDragging(event) {
      dragging = true;
      thumb.classList.add('is-dragging');
      event.stopPropagation();
      if (event.cancelable) event.preventDefault();
    }

    function stopDragging() {
      dragging = false;
      thumb.classList.remove('is-dragging');
    }

    previousButton.addEventListener('click', function() {
      wrapper.scrollBy({ top: -500, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function() {
      wrapper.scrollBy({ top: 500, behavior: 'smooth' });
    });

    track.addEventListener('click', function(event) {
      if (event.target === thumb) return;
      scrollFromTrackPosition(event.clientY, true);
    });

    track.addEventListener('touchstart', function(event) {
      if (event.target === thumb) return;
      if (event.cancelable) event.preventDefault();
      scrollFromTrackPosition(getTouchY(event), true);
    }, { passive: false });

    thumb.addEventListener('mousedown', startDragging);
    thumb.addEventListener('touchstart', startDragging, { passive: false });

    document.addEventListener('mousemove', function(event) {
      if (!dragging) return;
      if (event.cancelable) event.preventDefault();
      scrollFromTrackPosition(event.clientY);
    });

    document.addEventListener('touchmove', function(event) {
      if (!dragging) return;
      if (event.cancelable) event.preventDefault();
      scrollFromTrackPosition(getTouchY(event));
    }, { passive: false });

    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchend', stopDragging);
    document.addEventListener('touchcancel', stopDragging);

    thumb.addEventListener('keydown', function(event) {
      var target;

      if (event.key === 'ArrowUp') target = wrapper.scrollTop - 500;
      if (event.key === 'ArrowDown') target = wrapper.scrollTop + 500;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = wrapper.scrollHeight;
      if (target === undefined) return;

      event.preventDefault();
      wrapper.scrollTo({ top: target, behavior: 'smooth' });
    });

    wrapper.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    window.addEventListener('orientationchange', queueUpdate);
    window.addEventListener('load', queueUpdate);

    wrapper.querySelectorAll('img, video, iframe').forEach(function(media) {
      media.addEventListener('load', queueUpdate, { once: true });
      media.addEventListener('loadedmetadata', queueUpdate, { once: true });
    });

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(queueUpdate);
      observer.observe(wrapper);
      var gallery = wrapper.querySelector('.product-gallery-static');
      if (gallery) observer.observe(gallery);
    }

    queueUpdate();
  });
})();
